import React, { FunctionComponent, ReactNode } from 'react';
import * as styles from './ParagraphRenderer.style';

export interface ParagraphRendererProps {
  children: ReactNode,
}

const ParagraphRenderer: FunctionComponent<ParagraphRendererProps> = ({
  children,
}) => (
  <p css={styles.paragraph}>
    {children}
  </p>
);

export default ParagraphRenderer;
